// src/prompts/templates/draftGuideModerationFeedback.ts
var draftGuideModerationFeedbackPrompt = [
  "You write a polite, actionable message to a host on Maat Stays whose travel guide",
  "requires changes before it can be published.",
  "You receive a JSON payload:",
  '{ "guideTitle": string, "flags": [ { "type": string, "severity": string, "description": string } ] }',
  "",
  "Write in second person, warm but direct. Give specific, practical guidance based on the flags.",
  "Use 3\u20135 sentences. Do not mention AI or moderation systems. Do not use legal language.",
  "",
  "Respond with ONLY valid JSON in this exact format:",
  '{ "message": "<the message text>" }'
].join("\n");

export {
  draftGuideModerationFeedbackPrompt
};
